import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Grid, Typography } from '@mui/material';
import { DetalhesPeriodoCard } from './components/detalhes-periodo-card';
import { PathsEnum } from '@routes/enumerators/paths.enum';
import { useAppSelector } from '@store/hooks';
import { CalendarMonthOutlined } from '@mui/icons-material';
import { formatDate, getDateFromSap } from '@core/utils';
import { AlertComponent } from '@core/components/atoms/alert-component';

import { colaboradorService } from '@core/services';
import { selectorDetalhePeriodoFerias } from '@core/slice/detalhePeriodoFerias.slice';

interface IDetalhePeriodoFeriasProps {}

export const DetalhesPeriodo: React.FC<IDetalhePeriodoFeriasProps> = () => {
    const { inicioPeriodo, fimPeriodo } = useParams<{ inicioPeriodo?: string; fimPeriodo?: string }>();
    const formattedInicioPeriodo = formatDate(getDateFromSap(inicioPeriodo ?? ''), false);
    const formattedFimPeriodo = formatDate(getDateFromSap(fimPeriodo ?? ''), false);

    const { data, loading, error } = useAppSelector(selectorDetalhePeriodoFerias);

    useEffect(() => {
        if (inicioPeriodo && fimPeriodo) {
            colaboradorService.detalhePeriodoFerias(inicioPeriodo, fimPeriodo);
        }
    }, []);

    let sortedData: any[] = [];
    if (data && Array.isArray(data)) {
        sortedData = [...data].sort((a, b) => new Date(a.dataInicio).getTime() - new Date(b.dataInicio).getTime());
    }

    return (
        <Container maxWidth="xl">
            <Grid sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                <CalendarMonthOutlined />
                <Typography sx={{ fontWeight: 'bold' }}>
                    {formattedInicioPeriodo} até {formattedFimPeriodo}
                </Typography>
            </Grid>
            <Grid>
                {error && !loading ? (
                    <AlertComponent type="error" detailed={true} message={error ?? '-'} />
                ) : (
                    <>
                        {data && Array.isArray(data)
                            ? sortedData.map((detalhePeriodoFerias, index) => (
                                  <DetalhesPeriodoCard
                                      key={index}
                                      path={PathsEnum.DETALHESFERIAS}
                                      inicioPeriodo={inicioPeriodo ?? ''}
                                      dataInicio={detalhePeriodoFerias.dataInicio}
                                      diasProgramados={detalhePeriodoFerias.diasProgramados}
                                      diasAbono={detalhePeriodoFerias.diasAbono}
                                      adiantamento13={detalhePeriodoFerias.adiantamento13}
                                      descricaoStatus={detalhePeriodoFerias.descricaoStatus}
                                  />
                              ))
                            : ''}
                    </>
                )}
            </Grid>
        </Container>
    );
};
